'use strict';

var Provider = require('./components/Provider');
var connect = require('./components/connect');

module.exports = { Provider: Provider, connect: connect };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-redux/lib/index.js
 ** module id = 169
 ** module chunks = 0
 **/